<template>
  <v-row class="padding-20" justify="center" align="center">
    <v-row justify="start" align="start">
      <v-col cols="1"></v-col>
    </v-row>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Communities
          <v-btn fab color="accent" to="/addcommunity" top right absolute>
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <CommunitiesList />
        </v-card-text>
      </v-card>
    </v-col>
    <v-col cols="12">
      <v-card>
        <v-card-title>
          Administrators
          <v-btn fab color="accent" to="/addadmin" top right absolute>
            <v-icon>add</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text></v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import CommunitiesList from "../admin/CommunitiesList.vue";

export default {
  data: () => ({
    admins: [],
  }),
  components: {
    CommunitiesList,
  },
  methods: {
    addCommunity() {},
  },
  mounted() {
    if (
      !this.$store.state.admin.super &&
      !this.$store.state.admin.superVerified
    )
      this.$router.push("/nopermissions");
  },
  created() {},
};
</script>
